import { FC } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { TranslateFn } from '@ravago/shared/translations/client';

interface Props {
  translate: TranslateFn;
  firstName: string;
  lastName: string;
  email: string;
  companyName?: string;
  country?: string;
}
const CallOffContactInfo: FC<Props> = ({ translate, firstName, lastName, email, companyName, country }: Props) => (
  <Box direction="column">
    <Table stroked="horizontal" tableLayout="fixed" hover={false} rowDividers={false}>
      <TableBody>
        <TableRow>
          <TableCell>
            <Typography component="b" variant="small-highlight" color="primary">
              {translate('page-consumer.call-off-agreement-flyout.contact-person')}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="small">
              {firstName} {lastName}
            </Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Typography component="b" variant="small-highlight" color="primary">
              {translate('page-consumer.call-off-agreement-flyout.email')}
            </Typography>
          </TableCell>
          <TableCell wordBreak="all">
            <Typography variant="small">{email}</Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Typography component="b" variant="small-highlight" color="primary">
              {translate('page-consumer.call-off-agreement-flyout.company')}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="small">{companyName || '-'}</Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Typography component="b" variant="small-highlight" color="primary">
              {translate('page-consumer.call-off-agreement-flyout.country')}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="small">{country || '-'}</Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </Box>
);

export default CallOffContactInfo;
